import supabase from 'modules/core/supabase/supabase';
import { ShootoutAttempts } from 'shared/types/shootout';
import { emptyShootoutAttempts, toShootoutAttempt } from 'shared/utils/shootout';

/**
 * Удары серии пенальти из хронологии — в порядке пробития.
 *
 * Нужна отдельная выборка, а не пересчёт живых событий: при синхронизации все id
 * хронологии уезжают в `parsedEventsId`, и разбор событий их больше не тронет.
 * Без этого перезагрузка окна оверлея посреди серии оставляла бы на табло 0:0.
 */
export async function getShootout(matchId: number): Promise<ShootoutAttempts> {
  const data = await supabase.matchChronology.getRow(matchId);
  const attempts = emptyShootoutAttempts();
  if (!data) return attempts;

  for (const receivedEvent of data.chronology ?? []) {
    const attempt = toShootoutAttempt(receivedEvent.type);
    if (!attempt) continue;

    const side = receivedEvent.teamId === data.firstTeamId ? 'first' : 'second';
    attempts[side].push(attempt);
  }

  return attempts;
}
